"use strict";

var React = require('react');

var compose = require('../../hoc/compose');

var PropTypes = require('prop-types');

var Divider = function Divider(props) {
  var newProps = {
    className: props.getClassName(props["long"] ? 'divider-long' : 'divider-short'),
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  };
  return React.createElement('hr', newProps);
};

Divider.propTypes = {
  "long": PropTypes.bool
};
module.exports = compose(Divider);